"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _superagent = _interopRequireDefault(require("superagent"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _svgDefs = require("@homeaway/svg-defs");
var _reactButtons = require("@homeaway/react-buttons");
var _ICMenu = _interopRequireDefault(require("../ICMenu"));
var _Feedback = _interopRequireDefault(require("../Feedback"));
var _commons = require("../util/commons");
require("./styles.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Logo = function Logo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("style", null, ".st0", "{", "fill-rule:evenodd;clip-rule:evenodd;fill:#245abc", "}"), /*#__PURE__*/_react.default.createElement("g", {
    id: "Vrbo-Logo_Wordmark_Arctic-Fjord"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Logo-_x2F_-Wordmark"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Logo",
    className: "st0",
    d: "M284.8 44.4c9.7 1.3 16.2 8.5 14.9 22.6-3.2 34.6-33.5 70-78.3 69H220l.1-.2c43.9.1 71.3-36.4 74.4-68.8 1.2-12.7-4.7-19.2-13.3-20.4-12.7-1.7-28 5.9-37.2 18.8l-.3.4-.2-.2c9.8-14.8 27.1-23.1 41.3-21.2zm90.1-.4c29.7 1.7 38.3 23.3 38.1 35-.6 31.7-25.3 53.8-67.8 56.8l-1.3.1.1-.2c39.5-3 63.9-28.4 64.5-59.8.2-10.7-7.2-29.2-32.9-31.7l-.8-.1.1-.1zM217.8 9.6c4.5 5.8-1 17.5-4.1 25.3l-.1.3L189 98.5c-1.6 4.2-3.6 8.9-4 14-1 11.8 9.4 22.1 30.2 23.1h.6l-.1.2c-24.1-.7-35.7-12.5-34.6-25.6.4-5.1 2-9.3 3.6-13.1l.2-.5 24.4-62.7c3.2-8.7 7.5-17.3 3.1-22.6l-.2-.2v-.3l5.6-1.2zm152.7 34.1l-.1.2c-37 3-64 28.5-64.5 59.8-.2 10.7 7.4 29.5 32.9 31.7l.8.1-.1.2c-29.8-1.7-38.4-23.5-38.2-35.2.6-31.9 27.8-54.2 69.2-56.8zm-92.9 5c7.9 1.1 12.9 6.8 11.8 18-2.8 30.2-30 67.6-67.9 68.6h-1.2l.1-.2c34.6-2.1 61.3-40.5 63.9-68.5.9-9.8-3.6-15-10.4-15.9-9.7-1.3-21.8 5-29.5 15.2l-.3.4-.2-.2c8.5-12.1 22.3-19 33.7-17.4zm97-4.2c22.9 1.8 29.9 18.2 29.7 28.1-.5 30.6-24 59.5-59.1 62.6l-1.1.1.1-.2c31.6-3.2 55.2-35.3 55.7-65.6.2-8.9-6.4-22.5-24.9-24.7l-.6-.1.2-.2zM229.3 7.3c3.8 5-3.1 20-5.5 26.3l-.1.2-26.6 68c-1.6 4-4 10-4.5 15.1-.8 9.7 7.5 17 22.9 18h.5l-.1.2c-18.6-.7-28.1-9.6-27.2-20.4.4-5.1 2.4-10.1 4.1-14.2l.2-.5 25.8-66c2.8-6.8 8.4-19 4.7-24.9l-.2-.3v-.3l6-1.2zm141 37l-.1.2c-30.8 3.2-55 35.9-55.6 65.6-.2 8.9 5.4 22.7 24.7 24.7l.6.1-.1.2c-22.9-1.5-29.9-18.4-29.7-28.3.5-30.5 25.7-59.9 60.2-62.5zM241.2 4.9c1.9 5.5-6 23.5-7.5 27.7l-.1.2-28.4 72.7c-1.7 4.2-4.3 11.1-4.8 16.2-.5 5.4 2.2 9.2 7.7 11.1 3.6 1.3 6.7 1.8 7.9 1.9h.1l-.1.2c-13.3-.9-20.5-6.9-19.7-15.6.4-4.8 2.9-11 4.5-15.2l.2-.4 27.7-71c1.9-4.7 9.3-21.3 6.6-26l-.1-.2V6l6-1.1zm133.1 40.2c16 1.8 21.3 13 21.1 21.1-.5 29.4-22.6 64.9-50.2 68.4l-.8.1.1-.2c24.1-3.2 46.1-42.3 46.6-71.5.1-7.1-4.2-15.7-16.4-17.7l-.4-.1v-.1zM270.5 53c5.7.8 9.5 5.2 8.7 13.5-2.3 25-25.7 63.6-57.6 68l-1 .1.1-.2c29.2-6.1 51.1-45.3 53.3-68.3.6-6.8-2.4-10.5-7.3-11.2-6.8-.9-15.5 3.7-21.7 11.6l-.3.4-.2-.2c6.7-9.1 17.4-14.9 26-13.7zM8.3 18.8c3.2 2.3 6.9 5.3 10.3 21l.1.5 20.5 94.2h-4.6S14.3 41.1 14.3 41c-3-13.1-6.7-18.8-14-21.8L0 19v-.2h8.3zm15.4 0c.6 4.7 1.1 8 3.9 19.8l.1.6 20.7 95.3h-4.6l-20.6-95c-2.7-11-3.7-16.1-7-20.2L16 19v-.2h7.7zm346.3 26l-.1.2c-23.2 3.2-46.1 43-46.6 71.5-.1 7.1 4.2 16.1 16.5 17.8l.4.1-.1.2c-15.8-1.3-21.3-13.2-21.1-21.3.4-29.1 23.7-65.6 51-68.5zM111.4 57.9c2.6 0 4.1 1.5 4.3 4.2.2 4.5-5.6 17.8-8.4 24.7l-.1.3-19.1 47.3h-4.8l19.3-47.7c2.6-6.2 9-20.7 8.8-24.5-.1-1.8-1.1-2.6-2.5-2.6-3.5 0-9.4 8.5-13.4 17.1l-.2.4h-.2c3.8-9.7 10.3-19.2 16.3-19.2zm5.1-3.5c4.8 0 7.5 2.9 7.7 7.1.3 6.3-4.9 18.2-8 25.7l-.2.4-18.6 46.8h-4.8l18.9-47.2c2.7-7.1 8.5-19.9 8.2-25.6-.2-3.5-2.3-5.5-6-5.5-8.3 0-15.1 10.3-19.2 20.6l-.2.4h-.2c4-11.6 12-22.7 22.4-22.7zm10.3-7.1c9.2 0 14.2 5.8 14.6 13.3.5 9.5-3.2 18.6-6.9 27.7l-.2.6-17.6 45.5h-4.8l17.9-45.9c3.4-9 7.6-18.8 7.1-27.8-.4-6.8-4.8-11.7-12.9-11.7-16.8 0-26.5 13.1-30.8 27.7l-.1.4H93c3.8-15.7 14.7-29.8 33.8-29.8zm-5.2 3.4c7 0 10.9 4.4 11.2 10.2.4 8-4.1 18.4-7.3 26.7l-.2.6-18.1 46.2h-4.9L120.7 88c3.2-8 8.1-19.6 7.8-26.7-.3-5.1-3.6-8.8-9.4-8.8-12.3 0-20.8 11.7-25 24.3l-.1.4h-.2c3.8-13.6 12.9-26.5 27.8-26.5zm54.8-6.9c6 0 11 3.8 11.5 12.2.9 17.2-14.7 31.2-31.8 33.9l-.5.1-.2-.2c14.7-3.3 29.2-16.5 28.4-32-.4-7.3-4.8-10.8-10.1-10.8-9.8 0-18.4 8.3-23.8 19.2 0 .6-.1 1.1-.1 1.7 4.9-10.1 12.5-17.8 21-17.8 4.8 0 8.4 3.1 8.7 9.5.7 13.4-11.9 26.4-24.1 29.7l-.4.1-.2-.2c10.1-3.7 21.1-16.1 20.5-27.8-.3-5.3-3.4-8-7.4-8-7.4 0-14 7.4-18.6 16.8-.1.7-.2 1.4-.4 2.1 4-8.7 9.9-15.7 16-15.7 3.7 0 6 2.4 6.2 6.8.5 9.8-8.3 21.7-16.5 25.5l-.3.1-.2-.2c6-3.8 13.3-15.5 12.9-23.6-.2-3.3-1.9-5.3-4.9-5.3-4.9 0-10.1 6.9-13.8 14.9-.3 1.3-.7 2.6-1.1 3.8 3.5-8.1 8.2-15.7 11.9-15.7 2.4 0 3.4 1.6 3.5 4 .3 5.9-4.4 17.2-8.7 21.2l-.2.2-.2-.2c3.8-6.7 5.5-14.5 5.1-19.3-.1-1.3-.6-2.7-2.2-2.7-2.2 0-6.3 7.1-9.7 14.1l-.2.4c-.9 2.5-1.8 5-2.8 7.8l-.4 1-17.2 45h-4.8l17.4-45.3c3.7-9.7 7.3-18.1 6.7-28.9-.4-8.2-6.1-14.6-16.3-14.6-21.2 0-32.3 14.7-36.6 31.1l-.1.5h-.2c3.9-17.8 15.7-33.4 39.5-33.4 11.4 0 17.6 7.1 18.1 16.3.1 1.4.1 2.8.1 4.2 6-11.9 15.6-20.5 26.5-20.5zm76.8-41.4c1.6 1.7-9.4 28.3-10.3 30.8v.1l-29.5 75.6c-1.4 3.8-4.8 12.4-5.2 17.1-.4 4.8 3.2 7.2 8.1 8.1l.3.1-.1.2c-7.2-1.1-12.6-4.4-12.1-10.6.4-4.8 3.2-12.1 4.8-16.4l.2-.4 28.9-74.2c1.5-4.2 9-21.8 9-28.6v-.5l5.9-1.3zM374 45.7c9.3 1.5 12.8 7.9 12.7 14.1-.5 28.3-21.2 70.6-41.4 74.3l-.6.1.1-.2c16.5-3 36.9-49.3 37.4-77.3.1-5.2-2.1-9.1-8-10.7l-.3-.1.1-.2zM263.3 57.3c3.8.5 6.1 3.6 5.7 8.8-1.9 20-23.7 60.7-47.2 67.7l-.8.2.1-.3c20.6-8.8 41.1-50 42.7-67.7.4-3.9-1.5-6.3-4.2-6.6-4.1-.6-9.9 3-14.2 8.1l-.3.3-.2-.2c5.4-6.8 12.7-11.1 18.4-10.3zm106.4-11.9l-.1.2c-15.9 3.2-37.2 50.4-37.6 77.3-.1 5.2 1.8 9.6 8.1 10.8l.3.1-.1.2c-9.6-1-12.8-8.1-12.7-14.4.5-27.7 22.3-71.3 42.1-74.2zM265.6 0l-44.1 112.4c-1.7 4.2-5.4 12.8-5.8 17.5-.2 1.8.5 3.2 1.1 3.6l.1.1-.1.3c-.4-.1-.6-.2-1-.4-2.1-1-3.6-3.4-3.5-5.5.2-4.7 3.5-13 5.2-17.1l.1-.3 30-77.1c.5-1.4 12.2-30.2 12.1-32.2v-.1l5.9-1.2zM36.3 18.8c-1.2 3.9-1.9 9.5 1 21.6l.1.6 17.2 80.6-3 6.3-19.3-89c-2.4-10.5-2.7-14.8-2.6-19.8v-.3h6.6zm13.5 0v.2c-4.2 3.8-5.4 10.3-2.9 22.9l.1.5 13.8 66.4-3.1 6.4-15.6-74c-2.6-12.5-1.9-17.4.3-22.1l.1-.2h7.3v-.1zm19.1 0v.2c-11.8 2.3-15.3 8.8-12.4 23.7L67 95.9l-3.1 6.5-12-59.5c-3.7-17.7 2.9-22.5 6.1-24h10.9v-.1zm57.1 0v.2c-17.9 5.4-25.9 15.6-39.7 41.2l-.4.8-.3-.2C97.7 35.2 103.5 24.7 113 19l.3-.2H126zm-21.4 0v.2c-4.7 7-7.7 14.3-18.9 40.8l-.3.8-.4-.1c7.3-20.3 11.1-30.3 10.2-41v-.7h9.4zm-16.7 0c6.4 6.4 4.1 17-3 40.7l-.2.7-.3-.2c6.8-26.8 4.6-37.2-5.3-40.9l-.3-.1v-.2h9.1z"
  }))));
};
Logo.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 413 136"
};
var ICHeader = /*#__PURE__*/function (_Component) {
  function ICHeader(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.resolveLabel = function (label) {
      var translations = _this.props.translations;
      return translations && translations[label] ? translations[label] : label;
    };
    _this.getTitle = function () {
      var title = _this.props.title;
      if (!title) {
        return _this.state.title;
      }
      return _this.resolveLabel(title);
    };
    _this.showMenu = function () {
      _this.setState({
        showMenu: true
      });
    };
    _this.hideMenu = function () {
      _this.setState({
        showMenu: false
      });
    };
    _this.state = {
      showMenu: false,
      title: ICHeader.defaultProps.title,
      showLoginOrLogout: true
    };
    return _this;
  }
  _inheritsLoose(ICHeader, _Component);
  var _proto = ICHeader.prototype;
  _proto.componentWillMount = function componentWillMount() {
    var _this2 = this;
    var _this$props = this.props,
      navLinks = _this$props.navLinks,
      logInOut = _this$props.logInOut,
      navLinksUrl = _this$props.navLinksUrl;
    if (_commons.v2PathRegex.test(logInOut == null ? void 0 : logInOut.href)) {
      this.setState({
        showLoginOrLogout: false
      });
    }
    if (navLinks && logInOut) {
      return;
    }
    navLinksUrl = navLinksUrl || "/t/api/getHeaderData";
    _superagent.default.get(navLinksUrl).then(function (response) {
      var _response$body = response.body,
        appLinks = _response$body.appLinks,
        loginLink = _response$body.loginLink,
        title = _response$body.title;
      _this2.setState({
        appLinks: appLinks,
        loginLink: loginLink,
        title: title ? title : _this2.state.title
      });
    }).catch(function () {
      _this2.setState({
        appLinks: null,
        loginLink: null
      });
    });
  };
  _proto.getNavLabel = function getNavLabel(nav) {
    if (nav.value) {
      return nav.value;
    }
    return this.resolveLabel(nav.label);
  };
  _proto.getNavLinks = function getNavLinks() {
    var _this3 = this;
    var _this$props2 = this.props,
      activeLink = _this$props2.activeLink,
      navLinks = _this$props2.navLinks;
    var appLinks = this.state.appLinks;
    var links = navLinks ? navLinks : appLinks;
    var apps = links && links instanceof Array ? links.filter(function (nav) {
      return nav.application !== false;
    }) : null;
    if (!apps) {
      return null;
    }
    return apps.map(function (nav, i) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i,
        className: (nav.enabled === false ? "disabled" : "") + " " + (activeLink === nav.label ? "active" : "")
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: nav.enabled !== false ? nav.path : "#"
      }, _this3.getNavLabel(nav)));
    });
  };
  _proto.getLoginLogoutLink = function getLoginLogoutLink() {
    var logInOut = this.props.logInOut;
    var loginLink = this.state.loginLink;
    if (logInOut) {
      return logInOut.href;
    }
    if (loginLink) {
      return loginLink.path;
    }
    return "#";
  };
  _proto.getLoginLogoutLabel = function getLoginLogoutLabel() {
    var logInOut = this.props.logInOut;
    var loginLink = this.state.loginLink;
    if (logInOut) {
      return this.resolveLabel(logInOut.label);
    }
    if (loginLink) {
      if (loginLink.value) {
        return loginLink.value;
      }
      return this.resolveLabel(loginLink.label);
    }
    return "";
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      navLinks = _this$props3.navLinks,
      translations = _this$props3.translations,
      feedback = _this$props3.feedback;
    var _this$state = this.state,
      appLinks = _this$state.appLinks,
      showLoginOrLogout = _this$state.showLoginOrLogout;
    var links = navLinks ? navLinks : appLinks;
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ic-header"
    }, /*#__PURE__*/_react.default.createElement(_ICMenu.default, {
      mobile: true,
      activeLink: this.props.activeLink,
      visible: this.state.showMenu,
      navLinks: links,
      translations: translations,
      hideMenu: this.hideMenu
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "ic-header-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ic-nav-header"
    }, links && links.length > 0 && /*#__PURE__*/_react.default.createElement(_reactButtons.ButtonIcon, {
      className: "menu-icon",
      label: "menu",
      svgMarkup: _svgDefs.MENU__16,
      onClick: this.showMenu
    }), /*#__PURE__*/_react.default.createElement("span", {
      id: "ic-logo",
      className: "ic-logo"
    }, /*#__PURE__*/_react.default.createElement(Logo, null)), /*#__PURE__*/_react.default.createElement("span", {
      className: "ic-header-title"
    }, this.getTitle()), /*#__PURE__*/_react.default.createElement("nav", {
      className: "navbar navbar-default navbar-static-top nav-bar-styles",
      role: "navigation"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container-fluid"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "nav navbar-nav"
    }, this.getNavLinks())))), /*#__PURE__*/_react.default.createElement("div", {
      className: "ic-header-items-wrapper"
    }, feedback && /*#__PURE__*/_react.default.createElement("div", {
      className: "ic-header-items-right"
    }, /*#__PURE__*/_react.default.createElement(_Feedback.default, {
      feedback: feedback
    })), showLoginOrLogout && /*#__PURE__*/_react.default.createElement("a", {
      className: "ic-header-items-right",
      href: this.getLoginLogoutLink()
    }, this.getLoginLogoutLabel()))));
  };
  return ICHeader;
}(_react.Component);
ICHeader.defaultProps = {
  title: "Integration Central",
  navLinksUrl: "/t/api/getHeaderData"
};
ICHeader.propTypes = {
  /** application title or lingua key if translations prop is provided. */
  title: _propTypes.default.string,
  /** Navigation links to display on the header.
   * 'enabled' and 'application' are both defaulted to true.
   * Setting 'enabled' to false will render the link in disabled/non-clickable state.
   * Setting 'application' to false will not render the link.
   * 'path' - nav link href.
   * 'value' - label on nav link,
   * 'label' - lingua key, used when value is undefined.
   * 'contents' - has the same structure as navLinks and is used only in mobile view.
   */
  navLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    enabled: _propTypes.default.bool,
    application: _propTypes.default.bool,
    path: _propTypes.default.string,
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    contents: _propTypes.default.array
  })),
  /** login/logout links.
   * 'href' - login/logout link.
   * 'value' - label on login/logout link.
   * 'label' - lingua key, used when value is undefined.
   */
  logInOut: _propTypes.default.shape({
    href: _propTypes.default.string,
    value: _propTypes.default.string,
    label: _propTypes.default.string
  }),
  /** Enable feedback for ICHeader
   * 'label' - Text that viewer will see. Default value is 'Feedback'
   * 'referrer' - The text that will be prepended to any feedback sent by a user. Helps isolate origin of feedback.
   * 'reportIssueUrl' - path that should be configured for report issue service.
   */
  feedback: _propTypes.default.shape({
    label: _propTypes.default.string,
    referrer: _propTypes.default.string,
    reportIssueUrl: _propTypes.default.string
  }),
  /** URL for fetching links. This is used by the component to fetch navigation and login/logout links when navLinks or logInOut prop is not provided. */
  navLinksUrl: _propTypes.default.string,
  /** label of the navigation link that should be highlighted. Example for docs it would be 'ic.docs'. */
  activeLink: _propTypes.default.string,
  /** translations for navLinks[{label}] when navLinks[{value}] is not defined. */
  translations: _propTypes.default.objectOf(_propTypes.default.string)
};
var _default = exports.default = ICHeader;
//# sourceMappingURL=index.js.map